import dynamic from 'next/dynamic'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import ModalLegacy from './legacy-modal'

import type { ModalProps } from './legacy-modal'

// Lazy-load `ModalDS` so the web-ui `Modal` + `Sheet` (vaul `Drawer`) trees aren't pulled into the
// `_app` shared bundle. The DS path is feature-flagged via `shouldUseDesignSystem()`, so eagerly
// importing it would ship the entire DS tree to every visitor even before the flag rolls out.
// `ssr: true` (default) keeps the SSR pass intact — only the client bundle is split.
const ModalDS = dynamic(() =>
  import(/* webpackChunkName: "modal-ds" */ '@src/components/blocks/modal-ds').then(m => ({ default: m.ModalDS })),
)

const Modal = (props: ModalProps) => {
  if (shouldUseDesignSystem()) {
    return <ModalDS {...props} />
  }
  return <ModalLegacy {...props} />
}

export type { ModalProps }
export default Modal
